module.exports = __webpack_public_path__ + "media/images/metronic/portlet-expand-icon-4aad17be33bb61cad3ca21b7b9919d81.png";